var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.142 17.267a1 1 0 001.433-.004l.065-.067a1 1 0 00-.003-1.396l-2.698-2.756L20 13.031A1 1 0 0021 12.03v-.122a1 1 0 00-1.001-.999l-13.023.014L9.62 8.196A1 1 0 009.616 6.8l-.065-.067a1 1 0 00-1.433.004L3 12.014l5.142 5.253z",
    fill: "#9CA6AD"
  })));
};

export default SvgArrowLeft;